import React from 'react';

interface Props {
  name: string;
  label?: string;
  placeholder: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  value?: string;
  maxLength?: number;
  scrollable?: boolean;
  disabled?: boolean;
  className?: string;
}

const Textarea: React.FC<Props> = (props) => {
  const {
    name,
    label,
    placeholder,
    onChange,
    value,
    maxLength,
    scrollable,
    disabled = false,
    className,
  } = props;

  return (
    <div className="form">
      <div className="form__form-group mb-0">
        {label ? <span className="form__form-group-label">{label}</span> : null}
        <div className="form__form-group-field">
          <div className="form__form-group-input-wrap">
            <textarea
              id={name}
              name={name}
              placeholder={placeholder}
              disabled={disabled}
              maxLength={maxLength}
              onChange={onChange}
              value={value}
              style={{ overflow: scrollable ? 'auto' : 'hidden' }}
              className={className}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Textarea;
